


































































import {Component, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {RelatorioEntrega} from '@/model/resource/RelatorioEntrega'
import {InputRelatorioEntregaSchema} from '@/schema/resource/RelatorioEntrega/InputRelatorioEntregaSchema'
import moment from 'moment'

@Component
export default class PersistRelatorioEntregaView extends Vue {
  @Provide('validator') validator = this.$validator
  isGenerating = false

  schema = new InputRelatorioEntregaSchema()
  relatorioEntrega = new RelatorioEntrega()

  async gerarRelatorio() {
    const isValid = await this.validator.validateAll()
    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    const idResponsavel = this.relatorioEntrega?.responsavel?.$id
    const dataInicio = this.relatorioEntrega.periodoInicial
      ? this.formatDate(this.relatorioEntrega.periodoInicial)
      : ''
    const dataFim = this.relatorioEntrega.periodoFinal
      ? this.formatDate(this.relatorioEntrega.periodoFinal)
      : ''

    if (!idResponsavel) {
      this.$snotify.warning(
        $.t('schema.InputRelatorioEntrega.warning') as string
      )
      return
    }

    if (!dataInicio) {
      this.$snotify.warning(
        $.t('schema.InputRelatorioEntrega.initDateRequired') as string
      )
      return
    }

    if (dataFim) {
      if (this.diffInDays(dataInicio, dataFim) > 30) {
        this.$snotify.warning(
          $.t('schema.InputRelatorioEntrega.warningDateRange') as string
        )
        return
      }
    } else {
      if (this.diffInDays(dataInicio, this.formatDate(new Date())) > 30) {
        this.$snotify.warning(
          $.t('schema.InputRelatorioEntrega.warningDateRange') as string
        )
        return
      }
    }

    this.isGenerating = true

    const resp = await this.relatorioEntrega
      .getRelatorioEntrega(idResponsavel.toString(), dataInicio, dataFim)
      .catch(err => {
        console.log('err', err)
        if (err != null && err.response) {
          this.$snotify.error(err.response.data.message)
        }
      })
      .finally(() => {
        this.isGenerating = false
      })

    if (resp) {
      this.$snotify.success(
        $.t('schema.InputRelatorioEntrega.success') as string
      )

      const fileBlob = new Blob([resp.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const fileURL = window.URL.createObjectURL(fileBlob)

      const link = document.createElement('a')
      link.href = fileURL
      link.setAttribute(
        'download',
        'relatorio-entregas-' +
          moment(new Date()).format('DD-MM-YYYY-HH-MM') +
          '.xlsx'
      )
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(fileURL)
    }
  }

  diffInDays(start: string, end: string): number {
    const msPerDay = 1000 * 60 * 60 * 24
    return Math.ceil(
      Math.abs(new Date(end).getTime() - new Date(start).getTime()) / msPerDay
    )
  }

  formatDate(date: Date): string {
    const d = new Date(date)
    const month = '' + (d.getMonth() + 1)
    const day = '' + d.getDate()
    const year = d.getFullYear()
    return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-')
  }

  get responsavelLabelAndValue() {
    if (this.relatorioEntrega.responsavel?.razaoSocial) {
      return {
        label: $.t('schema.InputRelatorioEntrega.razaoSocial'),
        value: this.relatorioEntrega.responsavel.razaoSocial,
      }
    } else {
      return {
        label: $.t('schema.InputRelatorioEntrega.nomeFantasia'),
        value: this.relatorioEntrega.responsavel?.nomeFantasia,
      }
    }
  }
}
